<template>
  <div class="c-goikenBox">
    <div class="c-goikenBox_inner">
      <div class="c-goikenBox_title">
        ココナラへのご意見・要望を<br>
        お聞かせください
      </div>
      <div
        class="c-goikenBox_form"
        v-if="!isSend"
      >
        <textarea
          v-model="goikenBoxContent"
          name="goikenBox"
          id="goikenBox"
          class="c-goikenBoxContent"
          placeholder="サービスへのご意見、ご要望をお聞かせください。ご意見・ご要望に返信できないことをあらかじめご了承ください。"
        ></textarea>
      </div>
      <div
        class="c-goikenBox_done c-goikenBoxDone"
        v-else
      >
        <div class="c-goikenBoxDone_title">
          <div v-if="isSuccess">ご意見ありがとうございました</div>
          <div v-else>ご意見の投稿ができませんでした</div>
        </div>
        <div class="c-goikenBoxDone_body">
          <div v-if="isSuccess">
            頂いたご意見には必ずスタッフが目を通しています。ご意見に返信できないことをあらかじめご了承ください。<br>
            返信が必要な場合は、お問い合わせからご連絡ください。
          </div>
          <div v-else>
            システムエラーが発生しました。<br>
            返信が必要な場合は、お問い合わせからご連絡ください。
          </div>
        </div>
        <div class="c-goikenBoxDone_button">
          <component
            :is="isBusiness ? 'DButton' : 'CButtonV2'"
            :href="$coconala.url('/inquiry')"
            class="c-inquiryButton"
            :color="isBusiness ? 'primary' : 'thirdly'"
            :type="isBusiness ? 'outlined' : ''"
            :size="isBusiness ? 'medium' : 'm'"
            width="200px"
            :is-bold="true"
          >
            お問い合わせ
          </component>
        </div>
      </div>
      <div
        class="c-goikenBox_button"
        v-if="!isSend"
      >
        <component
          :is="isBusiness ? 'DButton' : 'CButtonV2'"
          @click="sendGoikenBox(goikenBoxContent)"
          class="c-goikenBoxButton"
          :color="isBusiness ? 'primary' : 'thirdly'"
          :type="isBusiness ? 'outlined' : ''"
          :size="isBusiness ? 'medium' : 'm'"
          width="200px"
          :is-bold="true"
        >
          送信する
        </component>
      </div>
    </div>
  </div>
</template>
<script>
// mixins
import formMixin from '~/mixins/form-mixin'
import DButton from '~/components/atoms/DS2/DButton'

export default {
  name: 'GoikenBox',
  components: {
    DButton
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    isBusiness: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSend: false,
      isSuccess: true,
      goikenBoxContent: ''
    }
  },
  methods: {
    async sendGoikenBox(contentBody) {
      try {
        await this.$store.dispatch('footer/sendGoikenBox', {
          contentBody
        })
      } catch (grpcCode) {
        this.isSuccess = false
      }
      this.isSend = true
    }
  }
}
</script>
<style lang="scss" scoped>
.c-goikenBox {
  margin-top: 16px;
  padding: 0 16px;
  border-radius: 4px;
  background: $color-beige-50;
  font-size: 13px;

  &_inner {
    padding: 12px 0 16px;
    color: $color-gray-800;
    text-align: center;
  }

  &_title {
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 15px;
  }
}

.c-goikenBoxContent {
  margin-bottom: 8px;
  padding: 12px;
  width: 100%;
  height: 130px;
  border: 1px solid $color-gray-300;
  border-radius: 5px;
  background: $color-white;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
}

.c-goikenBoxButton {
  width: 120px;
}

.c-goikenBoxDone {
  margin-bottom: 8px;
  padding: 12px;
  width: 100%;
  border-radius: 5px;
  background: $color-white;
  font-size: 12px;
  line-height: 1.5;

  &_title {
    margin-bottom: 8px;
    font-weight: bold;
  }

  &_body {
    margin-bottom: 8px;
    text-align: left;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-goikenBox {
    margin: 16px auto 0;
    max-width: 327px;
    width: calc(100% - 48px);
  }
}
</style>
